import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { container, goldBtnSm } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { to: "/about", label: "About" },
  { to: "/sectors", label: "Sectors" },
  { to: "/process", label: "Process" },
  { to: "/membership", label: "Membership" },
  { to: "/case-studies", label: "Case Studies" },
  { to: "/orla", label: "ORLA" },
  { to: "/contact", label: "Contact" },
];

export function PublicNav() {
  const [open, setOpen] = useState(false);
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();

  const dest = !user ? "/auth" : isAdmin ? "/admin" : user.status === "verified" ? "/deals" : "/access-pending";

  return (
    <header className="sticky top-0 z-50 bg-[hsl(var(--background)/0.78)] backdrop-blur-md border-b border-border">
      <div className={`${container} h-16 flex items-center justify-between`}>
        <Link to="/" className="pdg-serif text-lg tracking-[0.12em] text-foreground" data-testid="nav-logo">
          PRIME DEAL GATEWAY
        </Link>
        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) =>
                `text-sm pdg-link-underline transition-colors duration-200 ${
                  isActive ? "text-[hsl(var(--pdg-gold))]" : "text-foreground/75 hover:text-foreground"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <button onClick={() => navigate(dest)} data-testid="public-nav-portal-button" className={goldBtnSm}>
              Enter portal
            </button>
          ) : (
            <>
              <Link to="/auth" data-testid="public-nav-sign-in-link"
                className="text-sm text-foreground/75 hover:text-foreground transition-colors">
                Sign In
              </Link>
              <Link to="/auth?tab=apply" data-testid="public-nav-apply-for-access-button" className={goldBtnSm}>
                Apply for Access
              </Link>
            </>
          )}
        </div>
        <button className="lg:hidden text-foreground" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-border bg-[hsl(var(--pdg-charcoal))]">
          <div className={`${container} py-4 flex flex-col gap-1`}>
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
                className="py-2 text-sm text-foreground/80">{l.label}</Link>
            ))}
            <div className="h-px bg-border my-2" />
            {user ? (
              <button onClick={() => { setOpen(false); navigate(dest); }} className={goldBtnSm}>Enter portal</button>
            ) : (
              <div className="flex gap-3">
                <Link to="/auth" onClick={() => setOpen(false)} className="py-2 text-sm text-foreground/80">Sign In</Link>
                <Link to="/auth?tab=apply" onClick={() => setOpen(false)} className={goldBtnSm}>Apply for Access</Link>
              </div>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
